import { toast } from 'react-toastify';
import { apiChatExport as http } from '../http';
import { saveAs } from 'file-saver';

class ServiceExportsFLEXCHAT {
  constructor(path) {
    this.path = path;
  }

  getDownloads(type, queryParams = {}) {
    return http.get(`${this.path}/${type}/csv`, {
      params: {
        ...queryParams
      },
      responseType: 'blob'
    });
  }

  /**
   * Método generalizado para baixar relatórios de qualquer formato e com qualquer extensão de arquivos
   * desde que a rota do back-end siga o padrão `/relatorio/{typeOfReport}/{fileExtension}?{queryParams}&jwt={string}`
   * @param {'analytical' | 'analitico' | 'synthetic' | 'sintetico' } typeOfReport
   * @param {'csv' | 'xlsx' | 'pdf'} fileExtension
   * @param {Object} queryParams
   * @returns {Promise<void>}
   * @example
   * const service = new ServiceExportsFLEXCHAT('/api/reports');
   * service.downloadReport('analytical', 'csv', { startDate: '2023-01-01', endDate: '2023-01-31' }, 'jwt-token')
   */
  async downloadReport(typeOfReport, fileExtension, queryParams = {}, jwt) {
    if (!typeOfReport || !fileExtension || !jwt) {
      toast.error(`Algo deu errado ao fazer o download do relatório.`);
      throw new Error(
        'Missing required parameters: typeOfReport, fileExtension, and jwt are required.'
      );
    }
    const fileTypePath =
      fileExtension === 'csv' || fileExtension === 'xlsx'
        ? fileExtension
        : 'pdf';
    try {
      const response = await http.get(
        `${this.path}/${typeOfReport}/${fileTypePath}`,
        {
          params: {
            ...queryParams,
            jwt: localStorage.getItem('token'),
            request_by: localStorage.getItem('login')
          },
          responseType: 'blob'
        }
      );
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      });
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
      const fileName = `relatorio_${typeOfReport}_${timestamp}.${fileExtension}`;
      saveAs(blob, fileName);
    } catch (error) {
      toast.error(`Erro ao fazer o download do relatório: ${error.message}`);
      throw error;
    }
  }

  async downloadReportAsync(typeOfReport, fileExtension, queryParams = {}) {
    if (!typeOfReport || !fileExtension) {
      toast.error('Parâmetros inválidos para iniciar a geração do relatório.');
      throw new Error(
        'Missing required parameters: typeOfReport and fileExtension are required.'
      );
    }

    const fileTypePath = fileExtension;

    try {
      const response = await http.get(
        `${this.path}/${typeOfReport}/${fileTypePath}`,
        {
          params: {
            ...queryParams,
            request_by: localStorage.getItem('login')
          }
        }
      );

      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || 'Erro ao solicitar o relatório.';
      toast.error(errorMessage);
      throw error;
    }
  }

  getDownloadsCSVNewWindow(type, queryParams = {}) {
    const searchParams = new URLSearchParams();

    for (const [key, value] of Object.entries(queryParams)) {
      searchParams.append(key, value);
    }

    searchParams.append('jwt', localStorage.getItem('token'));

    return `${
      process.env.REACT_APP_CHANNEL_DOWNLOADS
    }relatorio/analitico/csv?${searchParams.toString()}`;
  }

  getDownloadsPDFNewWindow(type, queryParams = {}) {
    const searchParams = new URLSearchParams();

    for (const [key, value] of Object.entries(queryParams)) {
      searchParams.append(key, value);
    }
    searchParams.append('request_by', localStorage.getItem('name'));

    searchParams.append('jwt', localStorage.getItem('token'));

    return `${
      process.env.REACT_APP_CHANNEL_DOWNLOADS
    }relatorio/analitico/pdf?${searchParams.toString()}`;
  }

  getDownloadsPdf(type, queryParams = {}) {
    return http.get(`${this.path}/${type}/pdf`, {
      params: {
        ...queryParams
      },
      responseType: 'blob'
    });
  }

  getDownloadsUnified(type, queryParams = {}, midia) {
    return http.get(`${this.path}/unificado/${type}/${midia}`, {
      params: {
        ...queryParams
      },
      responseType: 'blob'
    });
  }
}

export default ServiceExportsFLEXCHAT;
